import { Typography } from '@mui/material'
import Stack from '@mui/material/Stack'
import { capitalize } from 'lodash'
import { useParams, Outlet } from 'react-router'

export default function SegmentLayout() {
	const { dog } = useParams()

	return (
		<Stack gap={3} alignItems="center">
			{dog && (
				<Typography variant="h2" textAlign={'center'}>
					{capitalize(dog)}
				</Typography>
			)}
			<Outlet />
		</Stack>
	)
}
